const baseUrl = "https://vitpyqback.vercel.app";
export default baseUrl;

// const baseUrl = "http://localhost:5000";
// export default baseUrl;

// const k = "hi";
